import QRCode from 'qrcode.react'
import {Button, Box, useMediaQuery, useTheme, Container, Grid} from '@mui/material'
import {useEffect, useState} from "react";

interface QrcodeProps {
    qr: string
}

function QrcodeElement(props: QrcodeProps) {
    const { qr } = props;
    // Переменные для адаптива под маленькие устройства
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
    const [targetQr, setTargetQr] = useState<string>();

    // download QR code
    const downloadQRCode = () => {
        const qrCodeURL = document.getElementById('qrImage') as HTMLCanvasElement
        const d = qrCodeURL.toDataURL("image/png").replace("image/png", "image/octet-stream");
        let aEl = document.createElement("a");
        aEl.href = `${d}`;
        aEl.download = "QR_Code.png";
        document.body.appendChild(aEl);
        aEl.click();
        document.body.removeChild(aEl);
    }

    useEffect(() => {
        setTargetQr(qr);
    }, [qr])


    return (
        <Box sx={{mt: 10, textAlign: 'center'}} >
            {qr !== "" &&
                <Box sx={{margin: 'auto'}}>
                    <QRCode
                        style={{margin: 'auto'}}
                        id="qrImage"
                        value={qr}
                        size={isSmallScreen ? 150 : 250}
                    />
                    <Button
                        style={{margin: '15px auto'}}
                        variant='contained'
                        color='success'
                        sx={{ display: "block", marginTop: 5}}
                        onClick={downloadQRCode}>
                        Download
                    </Button>
                </Box>
            }
        </Box>
    )
}
export default QrcodeElement